import { getPartnerOrgCategory } from './constants';
import type { Registration } from '../types';

/**
 * Resolve a Registration's partner-org classification bucket — always one of
 * 'industry' | 'government' | 'nps' | null. Approved partners read it
 * directly off `partner.organizationType` (already normalized by the
 * backend); pending registrations only have the raw `exhibitorOrgType`
 * string and get run through the same mapper.
 */
export function getOrgTypeBucket(reg: Registration): 'industry' | 'government' | 'nps' | null {
  if (reg.partner?.organizationType) {
    const t = reg.partner.organizationType.toLowerCase();
    if (t === 'industry' || t === 'government' || t === 'nps') return t;
    return getPartnerOrgCategory(reg.partner.organizationType) as 'industry' | 'government' | 'nps' | null;
  }
  return getPartnerOrgCategory(reg.exhibitorOrgType) as 'industry' | 'government' | 'nps' | null;
}
